import React from "react"
import { Col, Row } from "react-bootstrap"

function Bloc(props) {
  const { title, children } = props

  return (
    <>
      <header className="header-info simulation-bloc-header">
        <Row className="justify-content-between">
          <Col className="align-self-center">
            <h2>{title}</h2>
          </Col>
        </Row>
      </header>

      <div className="hard-shadow-white-block">{children}</div>
    </>
  )
}
export default Bloc
